module.exports = __webpack_public_path__ + "img/2.7b6d2395.jpg";